module.exports = __webpack_public_path__ + "img/homeicon.54e63f1f.svg";